import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { SelectIcon } from "App/Assets";
import { useDatatables } from "App/hooks";
import { TableRow } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { getCekResepIter } from "../../../utils";
import { Modal, useTabStyle } from "App/Component/ui";
import { Badge, IconButtonDatatable } from "App/Component/ui";
import { FreezeTable } from "components/organism";
import { defaultToastError, defaultDateDisplay } from "App/utils/helpers";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

const ModalCekResepIterasi = ({
  setShowModal,
  noRm,
  formData,
  setFormData,
}) => {
  const classes = useTabStyle();
  const [rows, setRows] = useState([]);

  const { setting } = useSelector((state) => state);
  const resepItterSettingan = setting.list_setting?.find((x) => x.kode_setting === "RESEP_ITER_BLOCK_ACT")
  const isSettingItterActive = resepItterSettingan?.setting_data_1
  const isSettingItterCount = resepItterSettingan?.setting_data_2

  const toDate = (v) => (v instanceof Date ? v : new Date(String(v)));
  const startOfDay = (v) => {
    const d = toDate(v);
    if (Number.isNaN(d.getTime())) throw new Error('Invalid date');
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };
  const addDays = (v, n) => {
    const d = startOfDay(v);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + Number(n || 0));
  };
  const toBool = (v) => v === true || v === 'true' || v === 1 || v === '1';
  const fmtID = (d) => d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });

  const handleSelectResepIter = (row) => {
    /*
      buatkan validasi tanggal dengan count ex: "tanggal_resep": "2025-09-23T08:19:43.992Z"
      validasi hitung count baca isSettingActive, jika isSettingActive true/hidup maka baca count.
    */
    const isActive = toBool(isSettingItterActive);

    // Jika setting TIDAK aktif → tidak pakai count → lolos tanpa validasi
    if (!isActive) {
      setFormData({
        ...formData,
        id_iterasi_resep: row?.id_iterasi_resep,
        id_resep_kronis: row?.id_resep_kronis,
        // no_apotik: row?.no_apotik,
        // no_resep: row?.no_resep
      });
      setShowModal(false);
      return;
    }

    // Setting aktif → pakai count
    const count = Number(isSettingItterCount);
    if (!Number.isFinite(count) || count <= 0) {
      defaultToastError('Nilai count harus lebih dari 0');
      return;
    }

    const resep0    = startOfDay(row?.tanggal_resep);
    const today0    = startOfDay(new Date());
    const threshold = addDays(resep0, count);

    if (today0.getTime() === resep0.getTime()) {
      defaultToastError('Tidak bisa di hari yang sama dengan tanggal resep.');
      return;
    }

    if (today0.getTime() < threshold.getTime()) {
      defaultToastError(`Belum bisa dipilih. Tersedia mulai ${fmtID(threshold)}.`);
      return;
    }

    setFormData({
      ...formData,
      id_iterasi_resep: row?.id_iterasi_resep,
      id_resep_kronis: row?.id_resep_kronis,
      // no_apotik: row?.no_apotik,
      // no_resep: row?.no_resep
    });
    setShowModal(false);
  };

  useEffect(() => {
    if (!noRm) {
      defaultToastError('Mohon Pilih Pasien Rekam Medis untuk melanjutkan.');
    }
    setNewData();
  }, []);

  const setNewData = async () => {
    const listRiwayatResepIter = await getCekResepIter(noRm);

    if (listRiwayatResepIter.state) {
      setRows(listRiwayatResepIter.data?.list);
    } else {
      setRows([]);
    }
  };

  return (
    <Modal title='List Riwayat Resep Iterasi' show={setShowModal} width='80%'>
      <div className={classes.root}>
        <div className={classes.rootTab}>
          <TableListRiwayatResepIter
            rows={rows}
            handleClickSelect={handleSelectResepIter}
          />
        </div>
      </div>
    </Modal>
  );
};

const TableListRiwayatResepIter = ({ rows, handleClickSelect }) => {
  return (
    <TableList
      rows={rows}
      handleClickSelect={handleClickSelect}
    />
  );
};

const TableList = ({ rows, handleClickSelect }) => {
  const { order, orderBy, length, handleRequestSort } = useDatatables({
    rows: rows,
    orderByDefault: "id_kunjungan_kronis",
    orderByRow: ["id_kunjungan_kronis"],
  });

  return (
    <>
      <FreezeTable
        title="Daftar Riwayat"
        maxHeight="300px"
        withExportButton={false}
        order={order}
        length={length}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        rows={rows}
        headCells={headCells}
      >
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow
              hover
              key={row.id_iterasi_resep}
              style={{
                backgroundColor: row.status === "Selesai" ? "#FFDDDD" : ""
              }}
            >
              <TableCell align="center"> {index + 1} </TableCell>
              <TableCell align="center">
                {row?.status !== "Selesai" && (
                  <IconButtonDatatable
                    color="secondary"
                    aria-label="delete"
                    onClick={() => handleClickSelect(row)}
                    style={{
                      background: "#D8D8D8",
                      borderRadius: "8px",
                      padding: "6px",
                    }}
                  >
                    <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                  </IconButtonDatatable>
                )}
              </TableCell>
              <TableCell>
                {row?.id_kunjungan_kronis === "0" ? "-" : row?.id_kunjungan_kronis}
              </TableCell>
              {/* <TableCell>{row?.id_resep}</TableCell> */}
              {/* <TableCell align="right">{row?.jumlah}</TableCell>
              <TableCell align="right">{row?.sisa}</TableCell> */}
              <TableCell>{row?.asal}</TableCell>
              <TableCell>{row?.nama_dokter}</TableCell>
              {/* <TableCell>{row?.no_apotik}</TableCell> */}
              <TableCell>{row?.no_sep}</TableCell>
              {/* <TableCell>{row?.no_resep}</TableCell> */}
              <TableCell>{defaultDateDisplay(row?.tgl_kunjungan)}</TableCell>
              <TableCell>{defaultDateDisplay(row?.tanggal_pelaksanaan_resep)}</TableCell>
              <TableCell>{defaultDateDisplay(row?.tanggal_sjp)}</TableCell>
              <TableCell>{defaultDateDisplay(row?.tanggal_resep)}</TableCell>
              <TableCell>
                <StatusRiwayatIter status={row?.status} />
              </TableCell>
            </TableRow>
          );
        })}

        {rows.length === 0 && (
          <TableRow>
            <TableCell align='center' colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
    </>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id_kunjungan_kronis",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "id_resep",
  //   disablePadding: true,
  //   label: "ID RESEP",
  //   sort: false,
  //   align: "left",
  //   minWidth: "100px",
  // },
  {
    id: "asal",
    disablePadding: true,
    label: "ASAL LAYANAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "jumlah",
  //   disablePadding: true,
  //   label: "JUMLAH",
  //   sort: false,
  //   align: "left",
  //   minWidth: "90px",
  // },
  // {
  //   id: "sisa",
  //   disablePadding: true,
  //   label: "SISA",
  //   sort: false,
  //   align: "left",
  //   minWidth: "90px",
  // },
  {
    id: "nama_dokter",
    disablePadding: true,
    label: "NAMA DOKTER",
    sort: false,
    align: "left",
    minWidth: "210px",
  },
  // {
  //   id: "no_apotik",
  //   disablePadding: true,
  //   label: "NO APOTEK ONLINE",
  //   sort: false,
  //   align: "left",
  //   minWidth: "150px",
  // },
  // {
  //   id: "no_sjp",
  //   disablePadding: true,
  //   label: "NO SJP",
  //   sort: false,
  //   align: "left",
  //   minWidth: "150px",
  // },
  {
    id: "no_sep",
    disablePadding: true,
    label: "NO SEP",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "no_resep",
  //   disablePadding: true,
  //   label: "NO RESEP",
  //   sort: false,
  //   align: "left",
  //   minWidth: "100px",
  // },
  {
    id: "tgl_kunjungan",
    disablePadding: true,
    label: "TANGGAL KUNJUNGAN",
    sort: false,
    align: "left",
    minWidth: "155px",
  },
  {
    id: "tanggal_pelaksanaan_resep",
    disablePadding: true,
    label: "TANGGAL PELAYANAN",
    sort: false,
    align: "left",
    minWidth: "155px",
  },
  {
    id: "tanggal_sjp",
    disablePadding: true,
    label: "TANGGAL SJP",
    sort: false,
    align: "left",
    minWidth: "155px",
  },
  {
    id: "tanggal_resep",
    disablePadding: true,
    label: "TANGGAL RESEP",
    sort: false,
    align: "left",
    minWidth: "155px",
  },
  {
    id: "status",
    disablePadding: true,
    label: "STATUS",
    sort: false,
    align: "left",
    minWidth: "130px",
  },
];

export const StatusRiwayatIter = ({ status }) => {
  if (status === "Selesai") {
    return <Badge color="green" label="Selesai" style={{
      padding:'0.2rem 0.8rem',
      fontSize:'11px'
    }}/>
  } else if (status === "Belum Selesai") {
    return <Badge color="warning" label="Belum Selesai" style={{
      padding:'0.2rem 0.8rem',
      fontSize:'11px'
    }}/>
  }
}

export default ModalCekResepIterasi;